/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  List, Checkbox, Segment,
  Header, Divider, Button, Dimmer,
  Loader, Grid
} from "semantic-ui-react";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const UtilsInstance = new Utils();

export class MonitorConfig extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      isSendingConfigDimmerActive: false,
      // ------- Protocol -------
      isRetriesProblemChecked: false,
      isDiagnosticProblemChecked: false,
      isFaultProblemChecked: false,
      // isFaultSequenceProblemChecked: false,
      isConfigErrorProblemChecked: false,
      isParamErrorProblemChecked: false,
      isMissingProblemChecked: false,
      isOnlineProblemChecked: false,
      isCriticalSlaveProblemChecked: false,
      isMasterFaultProblemChecked: false,
    };
  }

  retrieveData = () => {
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "tsExpertConfig", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        // ------- Protocol -------
        isRetriesProblemChecked: data.isRetriesProblemChecked,
        isDiagnosticProblemChecked: data.isDiagnosticProblemChecked,
        isFaultProblemChecked: data.isFaultProblemChecked,
        // isFaultSequenceProblemChecked: data.isFaultSequenceProblemChecked,
        isConfigErrorProblemChecked: data.isConfigErrorProblemChecked,
        isParamErrorProblemChecked: data.isParamErrorProblemChecked,
        isMissingProblemChecked: data.isMissingProblemChecked,
        isOnlineProblemChecked: data.isOnlineProblemChecked,
        isCriticalSlaveProblemChecked: data.isCriticalSlaveProblemChecked,
        isMasterFaultProblemChecked: data.isMasterFaultProblemChecked,
      }));
  }

  // ------ Toggle Protocol Checkboxes ---------
  toggleRetriesProblemCheckbox = () => {
    this.setState({ isRetriesProblemChecked: !this.state.isRetriesProblemChecked });
  }

  toggleDiagnosticProblemCheckbox = () => {
    this.setState({ isDiagnosticProblemChecked: !this.state.isDiagnosticProblemChecked });
  }

  toggleFaultProblemCheckbox = () => {
    this.setState({ isFaultProblemChecked: !this.state.isFaultProblemChecked });
  }

  toggleFaultSequenceProblemCheckbox = () => {
    this.setState({ isFaultSequenceProblemChecked: !this.state.isFaultSequenceProblemChecked });
  }

  toggleConfigErrorProblemCheckbox = () => {
    this.setState({ isConfigErrorProblemChecked: !this.state.isConfigErrorProblemChecked });
  }

  toggleParamErrorProblemCheckbox = () => {
    this.setState({ isParamErrorProblemChecked: !this.state.isParamErrorProblemChecked });
  }

  toggleMissingProblemCheckbox = () => {
    this.setState({ isMissingProblemChecked: !this.state.isMissingProblemChecked });
  }

  toggleOnlineProblemCheckbox = () => {
    this.setState({ isOnlineProblemChecked: !this.state.isOnlineProblemChecked });
  }

  toggleCriticalSlaveProblemCheckbox = () => {
    this.setState({ isCriticalSlaveProblemChecked: !this.state.isCriticalSlaveProblemChecked });
  }

  toggleMasterFaultProblemCheckbox = () => {
    this.setState({ isMasterFaultProblemChecked: !this.state.isMasterFaultProblemChecked });
  }

  // Save the TS Expert Configuration
  saveTsExpertConfiguration = () => {
    this.showSendingConfigDimmer();

    let data = {
      isRetriesProblemChecked: this.state.isRetriesProblemChecked,
      isDiagnosticProblemChecked: this.state.isDiagnosticProblemChecked,
      isFaultProblemChecked: this.state.isFaultProblemChecked,
      // isFaultSequenceProblemChecked: this.state.isFaultSequenceProblemChecked,
      isConfigErrorProblemChecked: this.state.isConfigErrorProblemChecked,
      isParamErrorProblemChecked: this.state.isParamErrorProblemChecked,
      isMissingProblemChecked: this.state.isMissingProblemChecked,
      isOnlineProblemChecked: this.state.isOnlineProblemChecked,
      isCriticalSlaveProblemChecked: this.state.isCriticalSlaveProblemChecked,
      isMasterFaultProblemChecked: this.state.isMasterFaultProblemChecked,
    };

    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "tsExpertConfig_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify(data)
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY);
      })
      .catch((error) => {
        alert(Strings.TS_EXPERT_CONFIG_SAVE_ERROR + Strings.REASON + error);
      })
      .finally(this.hideSendingConfigDimmer);
  }

  showSendingConfigDimmer = () => this.setState({ isSendingConfigDimmerActive: true });

  hideSendingConfigDimmer = () => this.setState({ isSendingConfigDimmerActive: false });

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
  }

  render() {
    return (
      <Segment doubling textAlign="left">
        <Header as='h2' textAlign="center" color="teal">
          {Strings.TS_EXPERT_PROT}
        </Header>
        <Divider clearing />

        <Segment id="problems-list" style={listSegmentStyle} basic>

          <List divided verticalAlign='middle'>

            <List.Item>
              <List.Content>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.CONFIG_RETRIES_LIST_HEADER}</List.Header>
                    {Strings.CONFIG_RETRIES_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleRetriesProblemCheckbox}
                      checked={this.state.isRetriesProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Content>
            </List.Item>

            <List.Item>
              <List.Content>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.CONFIG_DIAGNOSTIC_LIST_HEADER}</List.Header>
                    {Strings.CONFIG_DIAGNOSTIC_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleDiagnosticProblemCheckbox}
                      checked={this.state.isDiagnosticProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Content>
            </List.Item>

            <List.Item>
              <List.Content>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.CONFIG_FAULT_LIST_HEADER}</List.Header>
                    {Strings.CONFIG_FAULT_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleFaultProblemCheckbox}
                      checked={this.state.isFaultProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Content>
            </List.Item>

            {/* <List.Item>
            <List.Content>
              <Grid columns={2}>
                <Grid.Column width={14}>
                  <List.Header>{Strings.CONFIG_FAULT_SEQUENCE_LIST_HEADER}</List.Header>
                  {Strings.CONFIG_FAULT_SEQUENCE_LIST_CONTENT}
                </Grid.Column>
                <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                  <Checkbox
                    toggle
                    onChange={this.toggleFaultSequenceProblemCheckbox}
                    checked={this.state.isFaultSequenceProblemChecked} />
                </Grid.Column>
              </Grid>
            </List.Content>
          </List.Item> */}

            <List.Item>
              <List.Content>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.CONFIG_CONFIG_ERROR_LIST_HEADER}</List.Header>
                    {Strings.CONFIG_CONFIG_ERROR_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleConfigErrorProblemCheckbox}
                      checked={this.state.isConfigErrorProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Content>
            </List.Item>

            <List.Item>
              <List.Content>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.CONFIG_PARAM_ERROR_LIST_HEADER}</List.Header>
                    {Strings.CONFIG_PARAM_ERROR_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleParamErrorProblemCheckbox}
                      checked={this.state.isParamErrorProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Content>
            </List.Item>

            <List.Item>
              <List.Content>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.CONFIG_MISSING_LIST_HEADER}</List.Header>
                    {Strings.CONFIG_MISSING_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleMissingProblemCheckbox}
                      checked={this.state.isMissingProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Content>
            </List.Item>

            <List.Item>
              <List.Content>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.CONFIG_ONLINE_LIST_HEADER}</List.Header>
                    {Strings.CONFIG_ONLINE_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleOnlineProblemCheckbox}
                      checked={this.state.isOnlineProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Content>
            </List.Item>

            <List.Item>
              <List.Content>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.CONFIG_CRITICAL_SLAVE_LIST_HEADER}</List.Header>
                    {Strings.CONFIG_CRITICAL_SLAVE_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleCriticalSlaveProblemCheckbox}
                      checked={this.state.isCriticalSlaveProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Content>
            </List.Item>

            <List.Item>
              <List.Content>
                <Grid columns={2}>
                  <Grid.Column width={14}>
                    <List.Header>{Strings.CONFIG_MASTER_FAULT_LIST_HEADER}</List.Header>
                    {Strings.CONFIG_MASTER_FAULT_LIST_CONTENT}
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                    <Checkbox
                      toggle
                      onChange={this.toggleMasterFaultProblemCheckbox}
                      checked={this.state.isMasterFaultProblemChecked} />
                  </Grid.Column>
                </Grid>
              </List.Content>
            </List.Item>

          </List>

        </Segment>

        <Button
          fluid
          color="teal"
          content={Strings.SAVE}
          onClick={this.saveTsExpertConfiguration} />

        <Dimmer active={this.state.isSendingConfigDimmerActive} >
          <Loader size="big">{Strings.SENDING_TS_EXPERT_CONFIG_WAITING}</Loader>
        </Dimmer>

      </Segment>
    );
  }
}

const listSegmentStyle = {
  overflowY: "scroll",
  height: "56vh"
};

export default MonitorConfig;